import {Endpoint} from '@eryxcoop/appyx-comm';

export default class UpdateUserRolesEndpoint extends Endpoint {

  adaptValues({userEmail, deliverySites, roles}) {
    return {
      'delivery_site_user_roles_of_user': {
          'email': userEmail,
          'delivery_sites': this._adaptDeliverySites(deliverySites),
          'roles': roles
      }
    }
  }

  _adaptDeliverySites(deliverySites) {
    return deliverySites.map(deliverySite => {
          return {
            'customer': {
              'business_name': deliverySite.businessName,
            },
            'code': deliverySite.code,
          }
        }
    );
  }
}